import { c as _c } from "react/compiler-runtime";
import ItemWrapper from 'modules/stores/store/components/item-wrapper';
import { HeaderItemViewType } from 'modules/stores/store/content/header/types/header-interface';
import { useDeleteItem } from 'modules/stores/store/hooks/use-delete-item';
import HeaderItemContent from '../../components/header-item-content';
import { useActions } from './hooks/use-actions';
const HeaderContent = item => {
  const $ = _c(12);
  const {
    deleteHeader
  } = useActions();
  const {
    onDelete
  } = useDeleteItem();
  let t0;
  if ($[0] !== deleteHeader || $[1] !== item.id || $[2] !== item.itemId || $[3] !== onDelete) {
    t0 = () => onDelete({
      deleteCallback: () => deleteHeader(item.id),
      itemId: item.itemId
    });
    $[0] = deleteHeader;
    $[1] = item.id;
    $[2] = item.itemId;
    $[3] = onDelete;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const onDeleteHeader = t0;
  let t1;
  if ($[5] !== item.id || $[6] !== item.text || $[7] !== onDeleteHeader) {
    t1 = <HeaderItemContent onDelete={onDeleteHeader} id={item.id} title={item.text} />;
    $[5] = item.id;
    $[6] = item.text;
    $[7] = onDeleteHeader;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== item.itemId || $[10] !== t1) {
    t2 = <ItemWrapper id={item.itemId}>{t1}</ItemWrapper>;
    $[9] = item.itemId;
    $[10] = t1;
    $[11] = t2;
  } else {
    t2 = $[11];
  }
  return t2;
};
export default HeaderContent;